import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CouponForm from "./CouponsForm";
import { getCouponById, editCoupon } from "../../api/couponService";
import FullPageLoader from "../../common/FullPageLoader";

export default function EditCoupon() {
  const location = useLocation();
  const id = location?.state?.couponId;

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await getCouponById(id);
        setData(res?.data || res || {});
      } catch (error) {
        setData(null);
      } finally {
        setPageLoading(false);
      }
    };

    if (id) load();
    else setPageLoading(false);
  }, [id]);

  const handleUpdate = async (payload) => {
    setLoading(true);

    try {
      const res = await editCoupon(id, payload);
      return res;
    } catch (err) {
      throw err;
    } finally {
      setLoading(false);
    }
  };

  if (pageLoading) return <FullPageLoader text="Loading coupon details..." />;
  if (!data) return <div className="container-fluid p-4">Coupon not found</div>;

  return (
    <CouponForm
      onSubmit={handleUpdate}
      loading={loading}
      isEdit={true}
      initialData={data}
    />
  );
}
